import React from 'react'

export function GoogleTagManagerHead(props) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
      <!-- Google Tag Manager -->
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NDWRXJ');
      <!-- End Google Tag Manager -->
    `,
      }}
    />
  )
}

export function GoogleTagManagerBody(props) {
  return (
    <noscript
      dangerouslySetInnerHTML={{
        __html: `
      <!-- Google Tag Manager (noscript) -->
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NDWRXJ"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
      <!-- End Google Tag Manager (noscript) -->
    `,
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/shared/GoogleTagManager.jsx